import Vue from 'vue'
let featureGuideCom = null
const openFeatureGuide = () => {
  return new Promise(async (resolve) => {
    if (featureGuideCom) {
      featureGuideCom.show()
      return resolve()
    }
    try {
      const featureGuideModule = await import(/* webpackChunkName: "public-feature-guide" */ '@/layout/components/feature-guide/index.vue')
      const FeatureGuideRes = Vue.extend(featureGuideModule.default)
      const handleClose = () => {
        if (!featureGuideCom) return
        featureGuideCom.$destroy()
        featureGuideCom = null
        return resolve()
      }
      featureGuideCom = new FeatureGuideRes({
        propsData: {
          handleClose
        }
      }).$mount()
      document.body.appendChild(featureGuideCom.$el)

      featureGuideCom.show()
    } catch (error) {
      featureGuideCom = null
      console.error('[layout] 打开引导组件失败', error)
      return resolve()
    }
  })
}
export default openFeatureGuide



// WEBPACK FOOTER //
// ./src/layout/layout/setup/open-feature-guide.js